export const SIZES = [
  { key: 'fb', label: 'Facebook 4:3', w: 1440, h: 1080 },
  { key: 'ig_portrait', label: 'Instagram 4:5', w: 1080, h: 1350 },
  { key: 'ig_square', label: 'Instagram Square', w: 1080, h: 1080 },
];

export const ROOMS = [
  { key: 'oceans13', label: 'Oceans 13 — Bank Heist', info: 'OCEANS 13\nBANK HEIST\nOKINAWA\nRYCOM MALL', bg: 'Bank Vault' },
  { key: 'demolition', label: 'Demolition Abduction', info: 'DEMOLITION\nABDUCTION\nOKINAWA\nRYCOM MALL', bg: 'Demolition Warehouse' },
  { key: 'pirate', label: 'Pirate Ship', info: 'PIRATE SHIP\nTREASURE HUNT\nOKINAWA\nGATE 2 STREET', bg: 'Pirate Ship' },
  { key: 'sweet_escape', label: 'Bake Me Happy', info: 'BAKE ME HAPPY\nKITCHEN ESCAPE\nOKINAWA\nRYCOM MALL', bg: 'Escape Room' },
];

export const FONTS = ['Michroma', 'Audiowide', 'Anton', 'Bebas Neue', 'Orbitron', 'Russo One', 'Black Ops One', 'Bungee', 'Bangers', 'Permanent Marker', 'Pirata One', 'Creepster', 'Special Elite', 'Press Start 2P'];
export const FONT_CSS = 'https://fonts.googleapis.com/css2?family=Michroma&family=Audiowide&family=Anton&family=Bebas+Neue&family=Permanent+Marker&family=Pirata+One&family=Creepster&family=Orbitron:wght@900&family=Russo+One&family=Black+Ops+One&family=Bungee&family=Bangers&family=Special+Elite&family=Press+Start+2P&display=swap';

let _id = 0;
const nid = () => `l${++_id}`;

export const textLayer = (o) => ({ id: nid(), type: 'text', color: '#ffffff', font: 'Michroma', stroke: true, align: 'center', ...o });

export function buildLayers({ w, h }, room, people, logos) {
  const s = Math.min(w, h);
  const layers = [];
  if (people) {
    const scale = Math.min((w * 0.8) / people.width, (h * 0.68) / people.height);
    const pw = people.width * scale, ph = people.height * scale;
    layers.push({ id: nid(), type: 'image', role: 'people', src: people.url, ratio: people.height / people.width, w: pw, x: w / 2, y: h - ph / 2 });
  }
  layers.push(textLayer({ role: 'title1', text: 'OKI - ESCAPE', size: s * 0.065, x: w / 2, y: h * 0.06 }));
  layers.push(textLayer({ role: 'title2', text: 'ESCAPE ROOM', size: s * 0.034, color: '#e3251a', font: 'Audiowide', x: w / 2, y: h * 0.06 + s * 0.075 }));
  layers.push(textLayer({ role: 'title3', text: 'WE ESCAPED', size: s * 0.12, x: w / 2, y: h * 0.06 + s * 0.175 }));
  const lock = logos.find((l) => /escaped/i.test(l.name)) || logos[0];
  const eat = logos.find((l) => /eat/i.test(l.name));
  if (lock) layers.push({ id: nid(), type: 'image', role: 'lock', src: lock.url, ratio: lock.ratio || 1, w: s * 0.3, x: s * 0.18, y: h - s * 0.15 });
  if (eat) layers.push({ id: nid(), type: 'image', role: 'eat', src: eat.url, ratio: eat.ratio || 1.1, w: s * 0.15, x: w - s * 0.1, y: h - s * 0.11 });
  layers.push(textLayer({ role: 'info', backdrop: true, text: room.info, size: s * 0.03, color: '#ff2a1f', font: 'Audiowide', align: 'right', x: w - s * 0.03, y: h - s * 0.29 }));
  return layers;
}
